/* eslint-disable camelcase */
export default {
	change_order_number: 'Change number',
	merchant_info_change: 'Merchant info change',
	change_order_status: 'Change order status',
	data_change_type: 'Data change type',
	change_ou: 'Change ou',
	associated_merchant_number: 'Associated merchant number',
	change_applicant: 'Change applicant',
	change_description: 'Change description',
	change_content: 'Change content',
	base_info: 'Base Info',
	qualification_information: 'Qualification Information',
	change_date: 'Change date',
	reason_for_change: 'Reason for change',
	merchant: 'Merchant ID'
};
